/**
 * @generated SignedSource<<3f95e26cb0f3fb9e3a5941efad6905b2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrderEditFlightTicketUploadMutation$variables = {
  file: any;
  id: string;
};
export type OrderEditFlightTicketUploadMutation$data = {
  readonly uploadOrderFlightTicket: {
    readonly flightTicket: {
      readonly " $fragmentSpreads": FragmentRefs<"StoredFile_file">;
    } | null;
  };
};
export type OrderEditFlightTicketUploadMutation = {
  response: OrderEditFlightTicketUploadMutation$data;
  variables: OrderEditFlightTicketUploadMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "file"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "kind": "Variable",
    "name": "file",
    "variableName": "file"
  },
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "OrderEditFlightTicketUploadMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Order",
        "kind": "LinkedField",
        "name": "uploadOrderFlightTicket",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StoredFile",
            "kind": "LinkedField",
            "name": "flightTicket",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "StoredFile_file"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "OrderEditFlightTicketUploadMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Order",
        "kind": "LinkedField",
        "name": "uploadOrderFlightTicket",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StoredFile",
            "kind": "LinkedField",
            "name": "flightTicket",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fileName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "size",
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fb2c2ca119e60112b3c50e4d41c1eb53",
    "id": null,
    "metadata": {},
    "name": "OrderEditFlightTicketUploadMutation",
    "operationKind": "mutation",
    "text": "mutation OrderEditFlightTicketUploadMutation(\n  $id: ID!\n  $file: Upload!\n) {\n  uploadOrderFlightTicket(id: $id, file: $file) {\n    flightTicket {\n      ...StoredFile_file\n      id\n    }\n    id\n  }\n}\n\nfragment StoredFile_file on StoredFile {\n  fileName\n  size\n}\n"
  }
};
})();

(node as any).hash = "097b3a98e6ef951f1cd5af20b7c9bbb3";

export default node;
